// extracted by mini-css-extract-plugin
module.exports = {"operation_menu":"operation_menu--QU_V_","hot":"hot--1jSxf"};